import InsideSalesListTableRowActions from './InsideSalesListTableRowActions';

export default InsideSalesListTableRowActions;
